var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.isSmallerDevice(768) ? "smaller-screen" : "",attrs:{"id":"player_container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }